import instance from "../../services/api";

export const getLimits = () => {
  return instance(true)
    .get(`/partner/limits_report/`)
    .then((res = {}) => res?.data);
};
